import { render, staticRenderFns } from "./EmailRelatedObject.vue?vue&type=template&id=2df7c4a9&scoped=true&"
import script from "./EmailRelatedObject.vue?vue&type=script&lang=js&"
export * from "./EmailRelatedObject.vue?vue&type=script&lang=js&"
import style0 from "./EmailRelatedObject.vue?vue&type=style&index=0&id=2df7c4a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df7c4a9",
  null
  
)

export default component.exports